// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-zwEbmC5h","ad_1":"ad_1-2zT5L_YX","ad_2":"ad_2-2ivaP6H7"};